export default "__VITE_ASSET__DcGGazmM__"